import React, { useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";

export default function Signup() {
  const history = useHistory();

  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [loading, setLoading] = useState(false);

  // Modal State
  const [modal, setModal] = useState({
    show: false,
    isSuccess: false,
    message: "",
    redirect: null,
  });

  const showModal = (message, isSuccess = false, redirect = null) => {
    setModal({ show: true, isSuccess, message, redirect });
  };

  const closeModal = () => {
    const redirectPath = modal.redirect;
    setModal({ ...modal, show: false });
    if (redirectPath) history.push(redirectPath);
  };

  // ----------------- VALIDATION ------------------
  const validateForm = () => {
    if (!fullname.trim()) return "Full Name is required.";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Invalid email address format.";

    const phoneRegex = /^[0-9+()\-\s]{6,20}$/;
    if (!phoneRegex.test(phone)) return "Invalid phone number format.";

    if (password.length < 6)
      return "Password must be at least 6 characters long.";

    if (password !== confirmPassword)
      return "Passwords do not match.";

    if (!agreedTerms)
      return "Please accept the Terms & Conditions to proceed.";

    return null;
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      showModal(validationError, false);
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post("https://swiftexprofit.com/register", {
        fullname,
        email,
        phone,
        password,
      });

      showModal(
        res.data?.message || "Registration successful! Welcome aboard.",
        true,
        "/login"
      );
    } catch (error) {
      showModal(
        error.response?.data?.message || "Registration failed. Please try again.",
        false
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      style={{
        backgroundColor: "#0b0e11",
        backgroundImage: "radial-gradient(circle at 50% 0%, rgba(46, 176, 59, 0.15) 0%, transparent 70%)",
        color: "#e0e6ed",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        padding: "40px 20px",
      }}
    >
      {/* GLASS MODAL */}
      {modal.show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "16px",
          }}
        >
          <div
            style={{
              backgroundColor: "#181a20",
              border: `1px solid ${modal.isSuccess ? "#10b981" : "#f6465d"}`,
              borderRadius: "16px",
              padding: "32px 24px",
              width: "100%",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                backgroundColor: modal.isSuccess ? "rgba(46, 176, 59, 0.15)" : "rgba(246, 70, 93, 0.15)",
                color: modal.isSuccess ? "#10b981" : "#f6465d",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: "24px",
              }}
            >
              {modal.isSuccess ? "✓" : "✕"}
            </div>

            <h4 style={{ color: "#fff", fontWeight: "600", marginBottom: "8px" }}>
              {modal.isSuccess ? "Account Created" : "Registration Notice"}
            </h4>
            <p style={{ color: "#848e9c", fontSize: "14px", marginBottom: "24px", lineHeight: "1.5" }}>
              {modal.message}
            </p>

            <button
              onClick={closeModal}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: modal.isSuccess ? "#10b981" : "#f6465d",
                color: "#ffffff",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              {modal.isSuccess ? "Proceed to Login" : "Dismiss"}
            </button>
          </div>
        </div>
      )}

      {/* SIGNUP CONTAINER */}
      <div
        style={{
          width: "100%",
          maxWidth: "480px",
          backgroundColor: "#181a20",
          border: "1px solid #2b313a",
          borderRadius: "16px",
          padding: "40px 32px",
          boxShadow: "0 16px 32px rgba(0, 0, 0, 0.4)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <h2 style={{ color: "#ffffff", fontWeight: "700", fontSize: "28px", letterSpacing: "-0.5px" }}>
            Create Account
          </h2>
          <p style={{ color: "#848e9c", fontSize: "14px", marginTop: "6px" }}>
            Start your trading journey on SwiftEx
          </p>
        </div>

        <form onSubmit={handleSignup}>
          {/* FULL NAME */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", color: "#b7bdc6", fontSize: "13px", marginBottom: "6px", fontWeight: "500" }}>
              Full Name
            </label>
            <input
              type="text"
              placeholder="John Doe"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px 16px",
                backgroundColor: "#0b0e11",
                border: "1px solid #2b313a",
                borderRadius: "8px",
                color: "#ffffff",
                fontSize: "14px",
                outline: "none",
                transition: "border-color 0.2s",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#10b981")}
              onBlur={(e) => (e.target.style.borderColor = "#2b313a")}
            />
          </div>

          {/* EMAIL ADDRESS */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", color: "#b7bdc6", fontSize: "13px", marginBottom: "6px", fontWeight: "500" }}>
              Email Address
            </label>
            <input
              type="email"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px 16px",
                backgroundColor: "#0b0e11",
                border: "1px solid #2b313a",
                borderRadius: "8px",
                color: "#ffffff",
                fontSize: "14px",
                outline: "none",
                transition: "border-color 0.2s",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#10b981")}
              onBlur={(e) => (e.target.style.borderColor = "#2b313a")}
            />
          </div>

          {/* PHONE NUMBER */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", color: "#b7bdc6", fontSize: "13px", marginBottom: "6px", fontWeight: "500" }}>
              Phone Number
            </label>
            <input
              type="text"
              placeholder="+1 (555) 000-0000"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px 16px",
                backgroundColor: "#0b0e11",
                border: "1px solid #2b313a",
                borderRadius: "8px",
                color: "#ffffff",
                fontSize: "14px",
                outline: "none",
                transition: "border-color 0.2s",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#10b981")}
              onBlur={(e) => (e.target.style.borderColor = "#2b313a")}
            />
          </div>

          {/* PASSWORD */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ display: "block", color: "#b7bdc6", fontSize: "13px", marginBottom: "6px", fontWeight: "500" }}>
              Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="At least 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "12px 42px 12px 16px",
                  backgroundColor: "#0b0e11",
                  border: "1px solid #2b313a",
                  borderRadius: "8px",
                  color: "#ffffff",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                onBlur={(e) => (e.target.style.borderColor = "#2b313a")}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  color: "#848e9c",
                  fontSize: "12px",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* CONFIRM PASSWORD */}
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", color: "#b7bdc6", fontSize: "13px", marginBottom: "6px", fontWeight: "500" }}>
              Confirm Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Re-enter password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "12px 42px 12px 16px",
                  backgroundColor: "#0b0e11",
                  border: "1px solid #2b313a",
                  borderRadius: "8px",
                  color: "#ffffff",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                onBlur={(e) => (e.target.style.borderColor = "#2b313a")}
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  color: "#848e9c",
                  fontSize: "12px",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                {showConfirmPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* TERMS & CONDITIONS CHECKBOX */}
          <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "24px" }}>
            <input
              type="checkbox"
              id="agreedTerms"
              checked={agreedTerms}
              onChange={(e) => setAgreedTerms(e.target.checked)}
              style={{
                accentColor: "#10b981",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                marginRight: "10px",
                marginTop: "2px",
              }}
            />
            <label htmlFor="agreedTerms" style={{ color: "#848e9c", fontSize: "13px", cursor: "pointer", margin: 0, lineHeight: "1.4" }}>
              I agree to the{" "}
              <Link to="/terms-and-conditions" style={{ color: "#10b981", textDecoration: "none", fontWeight: "500" }}>
                Terms & Conditions
              </Link>
            </label>
          </div>

          {/* SUBMIT BUTTON */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#10b981",
              color: "#ffffff",
              fontWeight: "600",
              fontSize: "15px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              transition: "background-color 0.2s, opacity 0.2s",
            }}
          >
            {loading ? "Creating Account..." : "Create Account"}
          </button>
        </form>

        {/* LOGIN LINK FOOTER */}
        <div style={{ textAlign: "center", marginTop: "24px", fontSize: "14px", color: "#848e9c" }}>
          Already have an account?{" "}
          <Link to="/login" style={{ color: "#10b981", fontWeight: "600", textDecoration: "none" }}>
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}